import styled from 'styled-components';

export const Wrapper = styled.button<{
  floating: boolean;
  disabled: boolean;
  buttonWidth: string;
  leftPos: string;
}>`
  margin-top: ${({ floating }) => (floating ? '0' : '36px')};
  background: ${({ disabled }) =>
    disabled
      ? ' linear-gradient(-180deg, rgb(139, 143, 147) 0%, rgb(102, 107, 113) 100%)'
      : 'linear-gradient(180deg, #1642BE 0.69%, #173792 100%)'};
  border-radius: 8px;
  box-shadow: 0px 0px 15px -7px rgb(0 0 0 / 32%), 0px 0px 46px 8px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 24%);
  height: 80px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 24px;
  text-align: center;
  color: var(--colorWhite);
  border: none;
  outline: none;
  padding: 16px 24px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  width: ${({ buttonWidth }) => buttonWidth};
  bottom: ${({ floating }) => (floating ? '40px' : '0')};
  left: ${({ leftPos }) => leftPos};
  position: ${({ floating }) => (floating ? 'absolute' : 'relative')};
  z-index: 1;

  &:focus,
  &:hover {
    background: ${({ disabled }) =>
      disabled
        ? 'linear-gradient(-180deg, rgb(139, 143, 147) 0%, rgb(102, 107, 113) 100%)'
        : 'linear-gradient(0deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.08)), linear-gradient(180deg, #1642BE 0.69%, #173792 100%)'};
  }
`;
